import { Modal } from "antd";
import { AuthContext } from "context/AuthContext";
import { SignalContext } from "context/SignalContext";
import { StreamingCameraType } from "lib/types";
import { getCameraById } from "pages/dashboard/cases/service";
import { Playback } from "pages/dashboard/playback/playback";
import PlaybackControlBar from "pages/dashboard/playback/PlaybackControlBar";
import { useCommonService } from "pages/service";
import { useContext, useEffect, useState, useMemo, useRef } from "react";
import { SvgClose } from "ui/svgs";
import { useNavigate } from "react-router-dom";
import { USER_ROLE } from "lib/constants";
import { isSupportSinglePcV2 } from "lib/utils";

export default function PlaybackModal({
  visible,
  cameraId,
  alertTime,
  timelineInterval = 0.25,
  startAt,
  endAt,
  initialSeekAt,
  alertId,
  onClose,
  orgId,
}: {
  visible: boolean;
  cameraId: number;
  alertTime?: number;
  timelineInterval?: number;
  startAt: number;
  endAt: number;
  initialSeekAt?: number;
  alertId?: string;
  onClose: () => void;
  orgId: number;
}) {
  console.log("PlaybackModal:", startAt, endAt, initialSeekAt);
  const { getCredentials } = useCommonService();
  const { user } = useContext(AuthContext);
  const { sessionId } = useContext(SignalContext);
  const [streamingCameraPlayback, setStreamingCameraPlayback] =
    useState<StreamingCameraType>(null);
  const playBackRef = useRef(null);
  const [pause, setPause] = useState(false);
  const refPlayerContainer = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!playBackRef.current) return;
    if (visible && initialSeekAt)
      playBackRef.current?.handleSeekAt(initialSeekAt);
    //if (!visible) playBackRef.current?.handleSeekAt(alertTime - 1000 * 60 * 10);
  }, [visible]);

  useEffect(() => {
    if (!cameraId || orgId === undefined || orgId === null) return;
    getCameraById(cameraId, orgId).then(async (data) => {
      const dataCamera = data.data;
      const supportSinglePc = await isSupportSinglePcV2(dataCamera.data.devId);
      const streamingCamera: StreamingCameraType = {
        orgId: dataCamera.data.orgId,
        nvrId: dataCamera.data.nvrId,
        devId: dataCamera.data.devId,
        type: dataCamera.data.type,
        cameraId: cameraId,
        cameraName: dataCamera.data.name,
        token: user.token,
        sessionId: sessionId,
        cameraMac: dataCamera.data.macAddress,
        remoteIndex: dataCamera.data.remoteIndex,
        streamId: "1",
        status: dataCamera.data.status,
        siteId: dataCamera.data.siteId,
        siteName: dataCamera.data.siteName,
        capabilities: dataCamera.data.capabilities,
        nvr: dataCamera.data.nvr,
        videoInfo: {
          width:
            dataCamera.data?.subStream?.resolution?.width ||
            dataCamera.data?.mainStream?.resolution?.width,
          height:
            dataCamera.data?.subStream?.resolution?.height ||
            dataCamera.data?.mainStream?.resolution?.height,
          fps:
            dataCamera.data?.subStream?.frameRate ||
            dataCamera.data?.mainStream?.frameRate,
        },
        channelId: dataCamera.data.channelId,
      };
      if (!supportSinglePc) {
        const dataCredentials = await getCredentials([+dataCamera.data.nvrId]);
        streamingCamera.rtcToken = dataCredentials?.at(0).token;
        streamingCamera.turn = dataCredentials?.at(0).turn;
      }
      console.log("stateStreamingCamera setStreamId", dataCamera);
      setStreamingCameraPlayback(streamingCamera);
    });
  }, [cameraId]);
  const firsRecordedDate = useMemo(() => {
    return new Date(startAt);
  }, [startAt]);

  const isEndUser =
    user.role !== USER_ROLE.Inspector &&
    user.role !== USER_ROLE.Dispatcher &&
    user.role !== USER_ROLE.Operator;
  const disabledButtons = [
    "fastTimeChange",
    "speedChange",
    "resolutionChange",
    "audioMuted",
    "snapshot",
    "archive",
    "timelineInterval",
    "datePicker",
    "imgSearch",
    isEndUser ? "" : "download",
  ];

  return (
    <Modal
      open={visible}
      closable={false}
      footer={<></>}
      onCancel={onClose}
      width={760}
    >
      <div
        className="flex flex-col h-full gap-2 relative group"
        style={{ height: "500px" }}
      >
        <button
          className="invisible group-hover:visible absolute z-20 right-2 top-4 w-8 h-8 rounded-full bg-zinc-600 bg-opacity-50 hover:bg-zinc-500 fill-white flex items-center justify-center"
          onClick={onClose}
        >
          <SvgClose width={"16"} />
        </button>
        <Playback
          ref={playBackRef}
          refPlayerContainer={refPlayerContainer}
          firsRecordedDate={firsRecordedDate}
          disableSwitchArrow={true}
          streamingCameraPlayback={streamingCameraPlayback}
          audioMuted={true}
          streamId={1}
          startAtTimeline={startAt}
          endAtTimeline={endAt}
          streamEnd={endAt}
          timelineInterval={timelineInterval}
          pause={pause}
        />
        <div className="mt-2 relative">
          <PlaybackControlBar
            pause={pause}
            onPauseChange={setPause}
            streamingCameraPlayback={streamingCameraPlayback}
            refPlayerContainer={refPlayerContainer}
            startAtTimeline={startAt}
            progressTime={initialSeekAt / 1000}
            disabledButtonList={disabledButtons}
            height={"40px"}
          />
          {isEndUser && (
            <button
              className={
                "absolute right-4 top-1 float-right flex justify-center h-8 w-[150px] items-center rounded-lg bg-blue-600 text-sm text-white transition-colors hover:bg-blue-500 disabled:bg-blue-200 disabled:hover:bg-blue-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              }
              onClick={() => {
                navigate(
                  `/dashboard/playback/${streamingCameraPlayback?.cameraId}`,
                  {
                    state: {
                      alertSeekStart: initialSeekAt,
                      activeAlertId: alertId,
                    },
                  },
                );
              }}
            >
              View Full Playback
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}
